module.exports = __webpack_public_path__ + "static/media/bg-popup-rules.547a4d6a.png";